import { SET_SITE } from '../constants/actionTypes';

export const setSite = payload => {
  return {
    type: SET_SITE,
    payload
  };
};



// WEBPACK FOOTER //
// ./src/actions/site.js